<template>
  <div class="xcard">
    <v-toolbar-title class="mb-5 py-2" style="border-bottom: 1px solid #d4dbe0">
      <div class="d-flex flex-wrap justify-space-between align-center">
        <span>PRESUPUESTOS CONSOLIDADOS</span>

        <div style="max-width: 200px">
          <v-select
            :items="gestiones"
            label="Gestion"
            item-text="numero"
            item-value="id"
            v-model="gestionId"
            @input="setGestionId"
            placeholder=" "
            outlined
            dense
            hide-details />
        </div>
      </div>
    </v-toolbar-title>

    <v-row>
      <v-col cols="12" md="4" xl="3" class="pa-2 pb-0">
        <div class="d-flex align-center">
          <v-btn small class="mr-2 my-1" @click="mostrado = true">
            <v-icon>mdi-filter-plus</v-icon>
          </v-btn>

          <v-btn small class="mr-2 my-1" :disabled="items.length == 0" @click="descargar">
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>

          <v-btn small class="mr-2 my-1" :disabled="sedesSeleccionadas.length == 0" @click="listar">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>
      </v-col>

      <v-col cols="12" md="8" xl="9" class="pa-2 pb-0">
        <v-autocomplete
          v-model="sedesSeleccionadas"
          :disabled="estaActualizando || sedesAgrupadas.length === 0"
          :items="sedesAgrupadas"
          outlined
          small-chips
          dense
          color="blue-grey lighten-2"
          label="Seleccionar sedes"
          item-text="nombre"
          item-value="id"
          clearable
          multiple
          hide-details
          @input="listar">
          <template v-slot:selection="data">
            <v-chip
              class="my-1"
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              small
              @click:close="removerSedeSeleccionada(data.item)">
              {{ data.item.nombre }}
            </v-chip>
          </template>
          <template v-slot:item="data">
            <template>
              <v-list-item-content>
                <v-list-item-title>{{ data.item.nombre }}</v-list-item-title>
                <v-list-item-subtitle>{{ data.item.group }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" class="pa-2 pb-6">
        <v-tabs horizontal v-model="tabActivo" @change="listar">
          <v-tab> INGRESOS </v-tab>
          <v-tab> GASTOS </v-tab>
          <v-tab> GASTOS POR GRUPO </v-tab>
          <v-tab> GASTOS POR GRUPO POR MESES </v-tab>

          <v-tabs-items v-model="tabActivo">
            <v-tab-item transition="fade-transition">
              <ListadoPresupuestosConsolidados :items="items" :cargando="cargando" />
            </v-tab-item>

            <v-tab-item transition="fade-transition">
              <ListadoPresupuestosConsolidados :items="items" :cargando="cargando" />
            </v-tab-item>

            <v-tab-item transition="fade-transition">
              <ListadoPresupuestosAgrupadosConsolidados
                :items="items"
                :cargando="cargando"
                :tipo="tiposPresupuestosConsolidados.GASTO_POR_GRUPO" />
            </v-tab-item>

            <v-tab-item transition="fade-transition">
              <ListadoPresupuestosAgrupadosConsolidados
                :items="items"
                :cargando="cargando"
                :tipo="tiposPresupuestosConsolidados.GASTO_POR_GRUPO_POR_MESES" />
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-col>
    </v-row>

    <v-dialog v-model="mostrado" max-width="100%" scrollable persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Seleccionar Sedes</span>

          <v-btn
            v-if="sedesSeleccionadas.length == 0"
            small
            class="ml-4 my-1"
            color="primary"
            @click="sedesSeleccionadas = sedes.map((sede) => sede.id)">
            <v-icon>mdi-filter</v-icon>
          </v-btn>

          <v-btn
            v-else
            small
            class="ml-4 my-1"
            :color="sedesSeleccionadas.length == sedes.length ? 'primary' : ''"
            @click="sedesSeleccionadas = []">
            <v-icon>mdi-filter-off</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider class="my-0"></v-divider>

        <v-card-text class="pa-4">
          <v-progress-circular
            v-if="sedesAgrupadasPorUnidadNegocio.length === 0"
            indeterminate
            color="primary"></v-progress-circular>

          <div v-else v-for="sedeAgrupada in sedesAgrupadasPorUnidadNegocio" :key="sedeAgrupada.id">
            <h5 class="mt-4" style="background-color: #ebeff1">
              <v-checkbox
                :input-value="
                  sedeAgrupada.sedes.map((sede) => sede.id).every((sedeId) => sedesSeleccionadas.includes(sedeId))
                "
                value
                :label="sedeAgrupada.nombre"
                dense
                hide-details
                :indeterminate="
                  !sedeAgrupada.sedes.map((sede) => sede.id).every((sedeId) => sedesSeleccionadas.includes(sedeId)) &&
                  sedeAgrupada.sedes.map((sede) => sede.id).some((sedeId) => sedesSeleccionadas.includes(sedeId))
                "
                @change="(valor) => agregarQuitarTodas(valor, sedeAgrupada.sedes)">
              </v-checkbox>
            </h5>

            <v-row>
              <v-col cols="12" md="4" lg="3" xl="2" v-for="sede in sedeAgrupada.sedes" :key="sede.id">
                <v-checkbox
                  v-model="sedesSeleccionadas"
                  :label="sede.nombre"
                  :value="sede.id"
                  dense
                  hide-details></v-checkbox>
              </v-col>
            </v-row>
          </div>
        </v-card-text>

        <v-divider class="my-0"></v-divider>

        <v-card-actions>
          <v-btn color="blue darken-1" text @click.prevent="aceptar"> Aceptar </v-btn>

          <v-btn color="grey darken-1" text @click.prevent="mostrado = false"> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <notifications group="notifications" position="top right" />
  </div>
</template> 

<script>
import ListadoPresupuestosConsolidados from '../views/ListadoPresupuestosConsolidados.vue';
import ListadoPresupuestosAgrupadosConsolidados from '../views/ListadoPresupuestosAgrupadosConsolidados.vue';
import PresupuestosService from '../services';
import { TIPOS_PRESUPUESTOS, TIPOS_PRESUPUESTOS_CONSOLIDADOS } from '../utils';
import SedesUnidadesNegocioMixin from '../mixins/sedes-unidades-negocio-mixin';
import ReportesExcelService from '../services/reportes-excel';
import DescargarExcelMixin from '../mixins/descargar-excel.mixin';

export default {
  name: 'PresupuestosConsolidadosLayout',
  mixins: [SedesUnidadesNegocioMixin, DescargarExcelMixin],
  components: {
    ListadoPresupuestosConsolidados,
    ListadoPresupuestosAgrupadosConsolidados,
  },
  data() {
    return {
      getService: null,
      tabActivo: 0,
      tiposPresupuestosConsolidados: TIPOS_PRESUPUESTOS_CONSOLIDADOS,
      tabsValues: [
        TIPOS_PRESUPUESTOS_CONSOLIDADOS.INGRESO,
        TIPOS_PRESUPUESTOS_CONSOLIDADOS.GASTO,
        TIPOS_PRESUPUESTOS_CONSOLIDADOS.GASTO_POR_GRUPO,
        TIPOS_PRESUPUESTOS_CONSOLIDADOS.GASTO_POR_GRUPO_POR_MESES,
      ],
    };
  },
  computed: {
    tipoConsolidado() {
      return this.tabsValues[this.tabActivo];
    },
  },
  methods: {
    async listar() {
      let tipo = null;

      if (
        [this.tiposPresupuestosConsolidados.GASTO, this.tiposPresupuestosConsolidados.INGRESO].includes(
          this.tipoConsolidado,
        )
      ) {
        tipo = this.tipoConsolidado;
        this.getService = PresupuestosService.consolidadosGestion;
      }

      if (this.tipoConsolidado === this.tiposPresupuestosConsolidados.GASTO_POR_GRUPO) {
        tipo = TIPOS_PRESUPUESTOS.GASTO;
        this.getService = PresupuestosService.agrupadosConsolidadosGestion;
      }

      if (this.tipoConsolidado === this.tiposPresupuestosConsolidados.GASTO_POR_GRUPO_POR_MESES) {
        tipo = TIPOS_PRESUPUESTOS.GASTO;
        this.getService = PresupuestosService.agrupadosPorMesesConsolidadosGestion;
      }

      const params = {
        sedes: this.sedesSeleccionadas,
        tipo,
        gestion_id: this.gestionId,
      };

      this.listarMixin(params);
    },
    descargar() {
      let tipo = null;
      let servicio = null;

      if (
        [this.tiposPresupuestosConsolidados.GASTO, this.tiposPresupuestosConsolidados.INGRESO].includes(
          this.tipoConsolidado,
        )
      ) {
        tipo = this.tipoConsolidado;
        servicio = ReportesExcelService.consolidados;
      }

      if (this.tipoConsolidado === this.tiposPresupuestosConsolidados.GASTO_POR_GRUPO) {
        tipo = TIPOS_PRESUPUESTOS.GASTO;
        servicio = ReportesExcelService.agrupadosConsolidados;
      }

      if (this.tipoConsolidado === this.tiposPresupuestosConsolidados.GASTO_POR_GRUPO_POR_MESES) {
        tipo = TIPOS_PRESUPUESTOS.GASTO;
        servicio = ReportesExcelService.agrupadosPorMesesConsolidados;
      }

      const opciones = {
        params: {
          sedes: this.sedesSeleccionadas,
          tipo,
          gestion_id: this.gestionId,
        },
      };

      return this.descargarExcel(servicio, null, opciones);
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}
::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}
::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}

@media (max-width: 1264px) {
  .margen-top {
    margin-top: 6px !important;
  }
}

/* v-date-picker */
::v-deep .accent {
  background-color: #005caf !important;
  border-color: #005caf !important;
}
</style>